import { Checkbox, FormControlLabel, Typography } from '@material-ui/core'

import { addCommaToPrice } from '../../../../helpers/numbers'
import { getTranslate } from '../../../../localization'
import { ModifyReservationInput } from '../../../../types/modifyReserveTAPanel'
import { AddOnForModify } from '../../../../types/searchAvailability'
import { useStyles } from './styles/index.styles'

type Props = {
  data: AddOnForModify
  roomIndex: number
  modifyReservationInput: ModifyReservationInput
  setModifyReservationInput: React.Dispatch<
    React.SetStateAction<ModifyReservationInput>
  >
}
const AddOnRow = ({
  data,
  roomIndex,
  modifyReservationInput,
  setModifyReservationInput
}: Props) => {
  const classes = useStyles()

  return (
    <div className={classes.main}>
      <div className={classes.left}>
        <Typography variant="h5" className={classes.text}>
          {data.name}
        </Typography>
      </div>
      <div className={classes.middle}>
        <FormControlLabel
          className={classes.formcontrol}
          label={getTranslate('')}
          control={
            <Checkbox
              size="small"
              color="primary"
              disabled={!modifyReservationInput.roomStays[roomIndex].canModify}
              checked={data.included}
              onChange={() => {
                setModifyReservationInput((prev) => {
                  const updatedRoomStays = [...prev.roomStays]
                  const currentAddons = updatedRoomStays[roomIndex].addons || []
                  const addon = data.code

                  const newAddons = currentAddons.includes(addon)
                    ? currentAddons.filter((a) => a !== addon)
                    : [...currentAddons, addon]

                  updatedRoomStays[roomIndex] = {
                    ...updatedRoomStays[roomIndex],
                    addons: newAddons
                  }

                  return {
                    ...prev,
                    roomStays: updatedRoomStays
                  }
                })
              }}
            />
          }
        />
      </div>
      <div className={classes.right}>
        <Typography variant="h5" className={classes.text}>
          {`${addCommaToPrice(data.totalAmount)}  ${getTranslate(
            data.currency || ''
          )}`}
        </Typography>
      </div>
    </div>
  )
}

export default AddOnRow
